// extracted by mini-css-extract-plugin
module.exports = {"backBtn":"DatabaseSearches_backBtn__1tty_"};